import React from 'react';
import AvatarPlaceholder from '../AvatarPlaceholder';

interface AvatarComponentProps {
  img: string | null;
  text: string;
  size?: number;
}

const Avatar: React.FC<AvatarComponentProps> = ({ img, text }) => {
  if (!img || img === '')
    return (
      <AvatarPlaceholder
        text={text}
        className="h-10 w-10 inline-block rounded-full text-lg shadow-lg"
      />
    );

  return (
    <img
      className="h-10 w-10 inline-block rounded-full shadow-lg object-cover"
      src={img}
      alt={text}
    />
  );
};

export default Avatar;
